import mildHearingSideImage from '@/components/results-category/images/mild-hearing-side-image.webp';
import mildHearingIcon from '@/components/results-category/images/mild-hearing-icon.webp';
import normalHearingSideImage from '@/components/results-category/images/normal-hearing-side-image.webp';
import normalHearingIcon from '@/components/results-category/images/normal-hearing-icon.webp';
import severeHearingSideImage from '@/components/results-category/images/severe-hearing-side-image.webp';
import severeHearingIcon from '@/components/results-category/images/severe-hearing-icon.webp';
import { palette } from '@/theme/palette';
export var resultCategoryImages = {
    mildHearingSideImage: mildHearingSideImage,
    mildHearingIcon: mildHearingIcon,
    normalHearingSideImage: normalHearingSideImage,
    normalHearingIcon: normalHearingIcon,
    severeHearingSideImage: severeHearingSideImage,
    severeHearingIcon: severeHearingIcon,
};
export var severeCategory = {
    name: 'Moderate Hearing Loss',
    icon: severeHearingIcon,
    emphasizedText: 'moderate hearing loss',
    textColor: palette.custom.moderateCategory.main,
};
export var mildCategory = {
    name: 'Mild Hearing Loss',
    icon: mildHearingIcon,
    emphasizedText: 'mild hearing loss',
    textColor: palette.custom.mildCategory.main,
};
export var normalCategory = {
    name: 'Normal Hearing',
    icon: normalHearingIcon,
    emphasizedText: 'normal hearing',
    textColor: palette.custom.normalCategory.main,
};
